import '@babel/polyfill';
import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store/store';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/app-check';
import moment from 'moment';
import * as Sentry from '@sentry/vue';
import config from './config';
import ImageUploader from './views/components/ImageUploader';
import FullStory from './plugins/FullStory';
import CheckUserCredentials from './plugins/CheckUserCredentials';
import { ucfirst, userRole } from './plugins/filters';
import migrate from './migrations/to_1_1_0';
import { segmentStoreSubscriber } from './analytics/segment-store-subscriber';

// Initialize Firebase before installing plugins that subscribe to authentication.
firebase.initializeApp({
  apiKey: config.FIREBASE_APIKEY,
  authDomain: config.FIREBASE_AUTHDOMAIN,
  databaseURL: config.FIREBASE_DATABASEURL,
  projectId: config.FIREBASE_PROJECTID,
  storageBucket: config.FIREBASE_STORAGEBUCKET,
  messagingSenderId: config.FIREBASE_MESSAGINGSENDERID,
  appId: config.FIREBASE_APPID,
});

if ('development' === process.env.NODE_ENV) {
  firebase.firestore().settings({
    host: 'localhost:5002',
    ssl: false,
    // Required for running Cypress tests
    experimentalForceLongPolling: true,
  });

  firebase.auth().useEmulator('http://localhost:9099/');
  firebase.storage().useEmulator('127.0.0.1', 9199);
} else {
  const appCheck = firebase.appCheck();
  appCheck.activate(new firebase.appCheck.ReCaptchaV3Provider(config.FIREBASE_APPCHECK_TOKEN), true);
}

moment.locale('sl');
store.subscribeAction(segmentStoreSubscriber);

const app = createApp(App);
app.config.performance = config.PERFORMANCE;
app.config.globalProperties.$config = config;
app.config.globalProperties.$ucfirst = ucfirst;
app.config.globalProperties.$userRole = userRole;

app.component('ImageUploader', ImageUploader);

app.use(store);
app.use(router);
app.use(vuetify);
app.use(FullStory, { router });
app.use(CheckUserCredentials, { router });

Sentry.init({
  app,
  environment: process.env.NODE_ENV,
  dsn: 'https://b3a72fa8af53435ab5fa47ea8bddffef@sentry.io/1424504',
});

(async () => {
  await migrate(store);
  await router.isReady();
  window.app = app.mount('#app');
})();
